import i18n from './i18n';
import { TOptions } from 'i18next';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useI18nProvider = () => {
  const { t } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage('fr');
  }, []);
  const i18nProvider = {
    translate: (key: string, options?: TOptions, defaultMessage?: string) => {
      if (key === 'documentTitle.suffix') {
        return ' | EMA ComPare';
      }
      //@ts-expect-error - TO FIX
      return defaultMessage || String(t(key, options));
    },
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };

  return i18nProvider;
};
